import styled from 'styled-components';
import { FlexContainer } from '@taxdown/piccolo-web';
import { pxToRem } from 'Styles/utils/utils';
import { MOBILE_WIDTH } from 'Styles/variables/sizes';

export const Container = styled(FlexContainer)`
  background-color: ${({ theme: { colors } }) => colors.live_200};
  border: 1px solid ${({ theme: { colors } }) => colors.blue_5};
  padding: ${({ theme: { reference } }) => reference.dimension_16};
  border-radius: ${({ theme: { reference } }) => reference.dimension_10};
  opacity: 0.5px;
  @media screen and (max-width: ${MOBILE_WIDTH}) {
    padding: ${pxToRem(20)};
  }
`;

export const ButtonsContainer = styled(FlexContainer)`
  max-width: 358px;
  @media screen and (max-width: ${MOBILE_WIDTH}) {
    width: 100%;
  }
`;

export const Link = styled.a`
  text-decoration: underline;
`;

export const InputContainer = styled(FlexContainer)`
  max-width: 358px;
  padding: ${({ theme: { reference } }) => `0 ${reference.dimension_16}`};
  @media screen and (max-width: ${MOBILE_WIDTH}) {
    width: 100%;
  }
`;
